module.exports = __webpack_public_path__ + "img/logo_ko.74edd5fa.svg";